import { gql } from '@apollo/client';

const GET_COMPANY = gql`
  query GetCompany($id: Int!) {
    GetCompany(id: $id) {
      id
      name
      website
      addresses {
        id
        addressType {
          id
          name
          description
          isCompany
          isContact
        }
        zipCode
        region {
          id
          name
        }
        territory {
          id
          name
        }
        country {
          id
          name
        }
        state {
          id
          name
        }
        city
        pobox
        address
        formattedAddress
        isAddressInvalid
      }
      mainContact {
        id
        lastName
        firstName
        title
        businessInfo {
          mainEmail {
            email
          }
          mainPhone {
            phone
          }
        }
      }
      mainAddress {
        address
        zipCode
      }
      salesTeam {
        id
        name
      }
      phones {
        id
        phone
        areaCode
        countryCode
        extension
        phoneType {
          id
        }
      }
      emails {
        id
        email
        emailType {
          id
          name
          description
        }
      }
      companyType {
        id
        name
      }
      comments
      industries {
        id
        name
      }
      productPotentials {
        id
        name
      }
      tags {
        id
        name
      }
      privateTeam {
        id
        name
      }
      parent {
        name
        id
      }
      callPattern {
        id
        name
      }
      category {
        id
        name
      }
      shipDetail
      printName
      isActive
      hasPosAccount
      hasHolydayCard
      visitFrequency
      rank {
        id
        name
      }
    }
  }
`;

export default GET_COMPANY;
